// extracted by mini-css-extract-plugin
export default {"Logo":"_7UzUFFM","LogoContainer":"i9aiDkkb"};